import {Box, Paper, Typography} from '@mui/material';
import React, {useState} from 'react';
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {errorToast, successToast} from '../actions';
import {resetPassword, verifyToken} from '../api/users.service';
import {CustomButton, PasswordInput, Spinner} from '../components';
import {fieldError, isFieldIvalid} from '../utils/errorHandler';
import {useFormInput} from '../utils/utilities';

const ResetPassword = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [resetLoading, setResetLoading] = useState(false);
  const [error, setError] = useState('');
  const {token} = useParams();
  const navigate = useNavigate();
  const password = useFormInput('');
  const confirmPassword = useFormInput('');
  const disabled = !confirmPassword.value || !password.value;

  const onSubmit = e => {
    e.preventDefault();
    if (password.value !== confirmPassword.value) {
      setError("Passwords don't match");
    } else {
      setResetLoading(true);
      resetPassword(token, password.value, confirmPassword.value)
        .then(() => {
          dispatch(successToast('Password reseted successfully!'));
          navigate('/login');
        })
        .catch(() => {
          dispatch(errorToast('Token expired!'));
          navigate('/login');
        })
        .finally(() => setResetLoading(false));
    }
  };

  useEffect(() => {
    verifyToken(token)
      .then(response => {
        if (response.data) {
          setLoading(false);
        } else {
          dispatch(errorToast('Token is invalid'));
          navigate('/login');
        }
      })
      .catch(e => {
        dispatch(errorToast('Token is invalid'));
        navigate('/login');
      });
  }, []);

  return (
    <Box
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center">
      {loading ? (
        <Spinner />
      ) : (
        <Paper sx={{padding: '2.5rem'}}>
          <form onSubmit={onSubmit}>
            <Box display="flex" flexDirection="column" width="25rem">
              <Typography mb="3rem" variant="h4" alignSelf="center">
                New password
              </Typography>
              <PasswordInput
                {...password}
                onChange={txt => {
                  setError('');
                  password.onChange(txt);
                }}
                error={isFieldIvalid(error, 'password')}
                helperText={fieldError(error, 'password')}
                sx={{marginTop: '1.25rem', marginBottom: '1.25rem'}}
              />
              <PasswordInput
                error={isFieldIvalid(error, 'confirmPassword')}
                helperText={
                  fieldError(error, 'confirmPassword') ||
                  fieldError(error, 'token')
                }
                {...confirmPassword}
                onChange={txt => {
                  setError('');
                  confirmPassword.onChange(txt);
                }}
                sx={{marginTop: '1.25rem', marginBottom: '1.25rem'}}
              />
              <CustomButton
                loading={resetLoading}
                disabled={disabled}
                type="submit">
                Set new password
              </CustomButton>
            </Box>
          </form>
        </Paper>
      )}
    </Box>
  );
};

export default ResetPassword;
